// @flow

import type {_Action, ActionCreator} from '../../types';

import {getReportLink} from '../../../api/disputes';
import {selectSettingsMerchantID, selectTableFilter} from '../selectors';
import {makeToAPI} from '../tools/filter';

const ROOT_TYPE = '@publisher/support/disputes/report';

export const SET_AVAILABLE = `${ROOT_TYPE}/available`;
export const SET_FETCHING = `${ROOT_TYPE}/fetching`;
export const SET_ERROR = `${ROOT_TYPE}/error`;

export const setAvailable = (payload: boolean = false): _Action<boolean> => ({
  type: SET_AVAILABLE,
  payload
});

const setFetching = (payload): _Action<boolean> => ({
  type: SET_FETCHING,
  payload
});

const setErr = (payload): _Action<boolean> => ({
  type: SET_ERROR,
  payload
});

export const unsetErr = (): ActionCreator => dispatch => dispatch(setErr(false));

const handleDownload = (url: string): void => {
  const a = document.createElement('a');
  const body = document.body;

  a.href = url;
  a.setAttribute('download', 'disputes_report.csv');
  if (body) {
    a.style.display = 'none';
    body.appendChild(a);
    a.click();
    body.removeChild(a);
  }
};

export const download = (language: string, translations?: ?Object): ActionCreator => (
  dispatch,
  getState
) => {
  const state = getState();
  const merchantID = selectSettingsMerchantID(state);
  const filter = selectTableFilter(state);

  dispatch(setFetching(true));

  getReportLink(merchantID, makeToAPI(filter), language, translations)
    .then((link: string) => handleDownload(link))
    .catch(() => dispatch(setErr(true)))
    .finally(() => dispatch(setFetching(false)));
};
